import { PrimeIcons } from 'primeng/api';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { prototype, ...iconEnum } = PrimeIcons;

export const IconEnum = iconEnum;
export type IconEnum = (typeof IconEnum)[keyof typeof IconEnum];
